import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addRule: {
		id: 'servicedesk.automation.summary.header.add-button.add-rule',
		defaultMessage: 'Add rule',
		description: '',
	},
	limitReachedTooltip: {
		id: 'servicedesk.automation.summary.header.add-button.limit-reached-tooltip',
		defaultMessage: "You've reached the limit of {limit, number} rules in this project.",
		description: '',
	},
});
